import React from 'react';
import { Spinner } from '@deere/ux.uxframe-react';
import { SvgIcon } from '@material-ui/core';
import GetSignNowURL from '../ESignature/StatusDashboardStepper/getSignNowURL';

export const ErrorIcon = ({ className }) => (
    <div className={className}>
        <svg aria-hidden="true" focusable="false" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z" fill="#D24625" fillRule="nonzero"></path>
        </svg>
    </div>
)

export const SuccessIcon = ({ className, size }) => (
    <span className={className}>
        <svg aria-hidden="true" fill="#367c2b" focusable="false" height={size} viewBox="0 0 24 24" width={size} xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none">
            </path>
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z">
            </path>
        </svg>
    </span>
)


export const DocumentIcon = ({ className }) => (
    <div className={className}>
        <svg aria-hidden="true" fill="#666666" focusable="false" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 0h24v24H0z" fill="none"></path>
            <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"></path>
        </svg>
    </div>
)


export const PersonIcon = ({ className }) => (
    <div className={className}>
        <svg aria-hidden="true" fill="#666666" focusable="false" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"></path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
    </div>
)

export const WarningIcon = () => (
    <div>
        <svg
            aria-hidden="true"
            focusable="false"
            height="24"
            viewBox="0 0 24 24"
            width="24"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M0 0h24v24H0z" fill="none"/>
            <path
                d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
                fill="#D24625"
                fillRule="nonzero"
            />
        </svg>
    </div>
)

export const RefreshIcon = () => (
    <div>
        <svg aria-hidden="true" fill="#666666" focusable="false" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z">
            </path>
            <path d="M0 0h24v24H0z" fill="none"></path>
        </svg>
    </div>
)

export const SpinnerIcon = ({ size }) => (
    <Spinner accessibilityLabel="Processing..." animation="border" className={'uxf-spinner-border-' + size} />
)

export const HomeIcon = ({ color }) => (
    <SvgIcon>
        <svg aria-hidden="true" fill={color} focusable="false" height="23" viewBox="0 0 24 24" width="23" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"></path>
            <path d="M0 0h24v24H0z" fill="none">
            </path>
        </svg>
    </SvgIcon>
)

export function SignNowIcon({ signer, envelopeId }) {
    const handleSignNowClick = (e) => {
        e.stopPropagation();
        GetSignNowURL(envelopeId, signer);
    }
    return (
        <span className="pl-2" onClick={e => handleSignNowClick(e)} title="Sign now">
            <SvgIcon >
                <svg aria-hidden="true" className="pl-1" fill="#FFFFFF" focusable="false"
                    height="24" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M19 19H5V5h7V3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"></path>
                </svg>
            </SvgIcon>
        </span>
    )

}


